import React from 'react'
import { DatePicker } from 'antd'
import { Moment } from 'moment'
import { RangeValue } from 'rc-picker/lib/interface'

const { RangePicker } = DatePicker
type Props = {
  ranges?: RangeValue<Moment>
  setRanges: (values: RangeValue<Moment>) => void
}

export const Picker: React.FunctionComponent<Props> = ({
  ranges,
  setRanges,
}) => {
  return (
    <RangePicker
      style={{ width: '100%' }}
      value={ranges}
      size="large"
      format="DD.MM.YYYY"
      placeholder={['Оплачен от', 'до']}
      onChange={setRanges}
    />
  )
}
